import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Box, DialogTitle, DialogContent, DialogActions, Typography } from '@material-ui/core';
import { useRouteMatch } from 'react-router';

import { useCaptureApi } from 'src/services';
import { AlertWrapper, AutocompleteWrapper, DialogButton } from 'src/components';
import { useFetchStatus } from 'src/hooks';


const emptyOption = { label: '', value: '' };

const ProjectImportDialog = ({ options, actions }) => {

  const [ selectedCompany, setSelectedCompany ] = useState(emptyOption);
  const [ selectedProjects, setSelectedProjects ] = useState([]);
  const [ importableProjectsOptions, setImportableProjectsOptions ] = useState([]);

  const match = useRouteMatch();
  const { projectId } = match.params;

  const hasSelectedCompany = Boolean(selectedCompany.value);

  const { linkedCompaniesOptions } = options;

  const captureApi = useCaptureApi();

  const { fetchStatus, setFetchStatus, errorMessage, fetchStatusEnum, handleConfirm, hasError, setErrorMessage } = useFetchStatus({
    confirmFn: () => actions.importProjects({ projects: selectedProjects, companyId: selectedCompany.value }),
    closeFn: actions.closeDialog,
  });

  const { NOT_STARTED, ERROR } = fetchStatusEnum;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const importableProjects = await captureApi.getImportableProjects({
          monitorProjectId: projectId,
          ...(hasSelectedCompany ? { captureCompanyId: selectedCompany.value } : {}),
        });

        setSelectedProjects([]);
        setImportableProjectsOptions(importableProjects.map(ip => ({ label: ip.name, value: ip.id, data: ip })));
      } catch (e) {
        console.error(e);
        setErrorMessage(e.serverMessage || e.message);
        setFetchStatus(ERROR);
      }
    };
    fetchData();
  // eslint-disable-next-line
  }, [ selectedCompany ]);

  const handleCompany = (_, selectedCompany) => {
    setSelectedCompany(selectedCompany);
    setFetchStatus(NOT_STARTED);
  };

  const handleProject = (_, selectedProjects) => {
    setSelectedProjects(selectedProjects);
  };

  return (
    <>
      <DialogTitle id="form-dialog-title">
        Proyectos a importar
      </DialogTitle>
      <DialogContent>
        <Box p={1}>
          <Box my={2} >
            <Typography variant="caption" required>Compañía</Typography>
            <AutocompleteWrapper
              value={selectedCompany}
              options={linkedCompaniesOptions}
              onChange={handleCompany}
              getOptionSelected={(option, value) => (option.value === value.value || value.value === '')}
            />
          </Box>
          <Box my={2} >
            <Typography variant="caption" required>Proyectos</Typography>
            <AutocompleteWrapper
              openOnFocus
              value={selectedProjects}
              options={importableProjectsOptions}
              onChange={handleProject}
              getOptionSelected={(option, value) => option.value === value.value}
              disabled={!hasSelectedCompany}
              multiple
              { ...hasSelectedCompany ? {} : { placeholder: 'Debes seleccionar una compañía' } }
            />
          </Box>
          {hasError && <AlertWrapper severity="error">{errorMessage}</AlertWrapper>}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={actions.closeDialog}>Cancelar</Button>
        <DialogButton fetchStatus={fetchStatus} onClick={handleConfirm} color='primary'>Vincular</DialogButton>
      </DialogActions>
    </>
  );
};

ProjectImportDialog.propTypes = {
  actions: PropTypes.object,
  options: PropTypes.object,
};


export {
  ProjectImportDialog,
};
